module.exports = __webpack_public_path__ + "static/media/LogoIcon2025.98998794.svg";